module.exports = __webpack_public_path__ + "img/480.2a15f849.png";